import { render, staticRenderFns } from "./ProductFreebiesDetails.vue?vue&type=template&id=0c2543e7"
import script from "./ProductFreebiesDetails.vue?vue&type=script&lang=js"
export * from "./ProductFreebiesDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports